import { Injectable, Provider } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ICookieBannerService, ICookieBannerServiceToken } from './cookie-banner-service.interface';

@Injectable({
  providedIn: 'root'
})
export class CookieBannerService implements ICookieBannerService {
  private cookieBannerVisibilitySource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private cookieBannerVisibilityChanged: Observable<boolean>;

  public constructor() {
    this.cookieBannerVisibilityChanged = this.cookieBannerVisibilitySource.asObservable();
  }

  public cookieBannerVisibilityChangedGet(): Observable<boolean> {
    return this.cookieBannerVisibilityChanged;
  }

  public cookieBannerShow(): void {
    this.cookieBannerVisibilitySource.next(true);
  }

  public cookieBannerHide(): void {
    this.cookieBannerVisibilitySource.next(false);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const CookieBannerServiceProvider: Provider[] = [
  { provide: ICookieBannerServiceToken, useExisting: CookieBannerService }
];
